export function vsStatisticsDTO(data) {
  return {
    onboardedProptechs: data?.onboardedProptechs || 0,
    rejectedProptechs: data?.rejectedProptechs || 0,
    favorite: data?.favorite || 0,
    notFavorite: data?.notFavorite || 0,
    totalProptechMeetings: data?.totalProptechMeetings || 0,
    cancelProptechMeetings: data?.cancelProptechMeetings || 0,
  };
}